import { List as CatalogList } from './List';

export default CatalogList;
